module.exports = {
  recordingBackendUrl: process.env.REACT_APP_RECORDING_BACKEND_URL,
  backendURL: process.env.REACT_APP_BACKEND_URL || "wss://webrtc-be.video.jamkazam.com",
  localWsServerUrl: process.env.REACT_APP_JAMKAZAM_WS_SERVER || "ws://localhost:3040",
  turnServerUrl: process.env.REACT_APP_TURN_SERVER_URL || "coturn.jamkazam.com:3478",
  stunServerUrl: process.env.REACT_APP_STUN_SERVER_URL || "coturn.jamkazam.com:3478",
  options: {
    p2p: new URLSearchParams(window.location.search).get("p2p"),
    admin: new URLSearchParams(window.location.search).get("admin") || false,
    audiooff: new URLSearchParams(window.location.search).get("audiooff") || (new URLSearchParams(window.location.search).get("audio") === "true" ? false : true),
    enableAudio: process.env.REACT_APP_ENABLE_AUDIO === 'true' || new URLSearchParams(window.location.search).get("audio") === "true",
    token: new URLSearchParams(window.location.search).get("token") || null,
    name: new URLSearchParams(window.location.search).get("name") || null,
    canvas: new URLSearchParams(window.location.search).get("canvas") || false,
    session_creator: new URLSearchParams(window.location.search).get("session_creator") || false,
    dontuseturn: new URLSearchParams(window.location.search).get("dontuseturn"),
    adaptive: new URLSearchParams(window.location.search).get("adaptive"),
    simulcast: new URLSearchParams(window.location.search).get("simulcastoff") ? false : true,
    userInactivityTimeout: (new URLSearchParams(window.location.search).get("inactivity_timeout") !== null
      ? parseInt(new URLSearchParams(window.location.search).get("inactivity_timeout")) * 1000
      : (window.location.hostname.includes('jamkazam.com') ? 240 * 60 * 1000 : 10 * 60 * 1000)),
    userInactivityCountdownThreshold: 60 * 1000,
    userInactivityCountdownTotal: 60,
    demo_user_timeout: new URLSearchParams(window.location.search).get("demo_user_timeout") === "true",
    demo: new URLSearchParams(window.location.search).get("demo") === "true",
    demo_session_ended: new URLSearchParams(window.location.search).get("demo_session_ended") === "true",
    demo_timer_seconds: parseInt(new URLSearchParams(window.location.search).get("demo_timer_seconds")) || null,
    broadcast_controls_location: new URLSearchParams(window.location.search).get("broadcast_controls_location") || 'none',
    maxCameras: 2,
    p2pThreshold: 4
  },
  peerToBitrateMapping: {
    "1": 3,
    "2": 2.3,
    "3": 1.7,
    "4": 1.5,
    "5": 1.2,
    "6": 1,
    "7": 0.7,
    "8": 0.6,
    "9": 0.5,
    "10": 0.5
  },
  aspectRatios: {
    "0": { height: 180, width: 320 },
    "1": { height: 360 * 1.5, width: 640 * 1.5 },
    "2": { height: 720, width: 1280 },
    "3": { height: 1280, width: 1920 },
  }
}
